import React from "react"
import PropTypes from "prop-types"

const ArrowRightThinIcon = ({ style }) => (
  <svg style={style} viewBox="0 0 27 52">
    <path fill="currentColor" d="M1.43,52L0,50.57,24.56,26,0,1.43,1.43,0,26.7,25.28a1,1,0,0,1,0,1.43Z"></path>
  </svg>
)

ArrowRightThinIcon.propTypes = {
  style: PropTypes.object
}

export default ArrowRightThinIcon



// WEBPACK FOOTER //
// ./src/AtomicComponents/Icons/ArrowRightThinIcon.jsx